import Box from "@mui/material/Box";
import { alpha } from "@mui/material/styles";
import type { SxProps, Theme } from "@mui/material/styles";
import type { ElementType } from "react";

interface ConsoleSurfaceProps {
  children: React.ReactNode;
  component?: ElementType;
  sx?: SxProps<Theme>;
}

/**
 * Shared dark card/panel surface for the Situate console.
 * Standardizes the background fill, border, and border-radius used across operational panels.
 */
export function ConsoleSurface({ children, component = "div", sx }: ConsoleSurfaceProps) {
  return (
    <Box
      component={component}
      sx={[
        (theme) => ({
          backgroundColor: alpha(theme.palette.background.paper, 0.78),
          border: `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
          borderRadius: `${theme.shape.borderRadius}px`,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
}
